var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"enter":_vm.enter,"appear":_vm.enter}},[_c('div',{class:_vm.$style.entity},[_c('emoji-icon',{attrs:{"icon":_vm.icon,"size":40}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }